import React, { FC, useEffect, useState } from 'react'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'
import { COLOR_ICON_NAMES, ColorIconName, ToastMessage } from '@dashboard/lib/types'
import ColorIcon from '@dashboard/components/ColorIcon'
import { useTimeouts } from '@dashboard/hooks/useTimeouts'
import { dismissToast } from '@dashboard/store/actions/user/toast/update'
import { useAppDispatch } from '@dashboard/hooks/useAppDispatch'

interface OwnProps {
  toast: ToastMessage
}

const classNames = classNamesBind.bind(css)
const TIME_ON_SCREEN = 8000
const ANTIMATION_DURATION = 300

const PieceOfToast: FC<OwnProps> = ({
  toast: { title, subtitle, icon, id, read },
}: OwnProps) => {
  const timers = useTimeouts()
  const [hasBeenDisplayed, setHasBeenDisplayed] = useState(false)
  const [isRead, setIsRead] = useState(false)
  const dispatch = useAppDispatch()

  // Functions
  const isIconName = (icon: string | null): icon is ColorIconName => {
    if (icon === null) return false

    return (COLOR_ICON_NAMES as readonly string[]).includes(icon)
  }

  // Effects
  useEffect(() => {
    setIsRead(read)
    timers.push(
      window.setTimeout(() => {
        setHasBeenDisplayed(true)
      }, TIME_ON_SCREEN),
    )
    timers.push(
      window.setTimeout(() => {
        dispatch(dismissToast(id))
      }, TIME_ON_SCREEN + ANTIMATION_DURATION),
    )
  }, [read])

  // Partials
  const renderIcon = () => {
    if (!icon) return null

    return (
      <ColorIcon
        icon={icon.name}
        width={20}
        discType={icon.discType}
        color={icon.color}
      />
    )
  }

  const renderSubtitleIcon = (icon: ColorIconName) => {
    return (
      <div key={`key-${icon}-${id}`} className={classNames('subtitleIcon')}>
        <ColorIcon icon={icon} width={14} discType="midnight" />
      </div>
    )
  }

  const renderSubtitlePart = (subtitleSection: string) => {
    if (isIconName(subtitleSection)) return renderSubtitleIcon(subtitleSection)

    return (
      <div
        key={`subtitle-${subtitleSection}-${id}`}
        className={classNames('subtitlePart')}
      >
        {subtitleSection}
      </div>
    )
  }

  const renderSubtitle = () => {
    return subtitle.split(new RegExp(':', 'g')).map(renderSubtitlePart)
  }

  return (
    <div
      className={classNames('container', {
        unread: !isRead,
        timeout: hasBeenDisplayed,
      })}
    >
      <div className={classNames('iconColumn')}>{renderIcon()}</div>
      <div className={classNames('textColumn')}>
        <div className={classNames('title')}>{title}</div>
        <div className={classNames('subtitle')}>{renderSubtitle()}</div>
      </div>
    </div>
  )
}

export default PieceOfToast
